var exports = {
  "kL": "xa15a2ab7--81027a--container",
  "iE": "xa15a2ab7--81027a--wrapper",
  "wm": "xa15a2ab7--81027a--logo",
  "UE": "xa15a2ab7--81027a--arrow",
  "mr": "xa15a2ab7--81027a--old-price",
  "q9": "xa15a2ab7--81027a--price",
  "Qs": "xa15a2ab7--81027a--content",
  "Qq": "xa15a2ab7--81027a--text",
};

module.exports = exports;
